import { useQuery } from "@tanstack/react-query";

import { tenantQueryOptions } from "@/query/tenant";

/** Whether the clinic takes a cancellation fee from the card on file, for patient-facing cancel dialogs. */
export function useAutoChargeCancellationFees(): boolean {
  const { data } = useQuery({
    ...tenantQueryOptions.public(),
    select: (tenant) => tenant?.autoChargeCancellationFees ?? false,
  });
  return data ?? false;
}
